(function () {
  document.documentElement.classList.remove('no-js');

  document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelector('[data-mobile-nav]')?.classList.add('open');
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelector('[data-mobile-nav]')?.classList.remove('open');
    });
  });

  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const slides = hero.querySelectorAll('.hero-slide');
    const dots = hero.querySelector('.hero-dots');
    if (slides.length < 2 || !dots) return;
    let i = 0;
    let timer;
    slides.forEach((_, idx) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (idx + 1));
      if (idx === 0) b.classList.add('active');
      b.addEventListener('click', () => go(idx));
      dots.appendChild(b);
    });
    function go(n) {
      slides[i].classList.remove('active');
      dots.children[i]?.classList.remove('active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('active');
      dots.children[i]?.classList.add('active');
      restart();
    }
    function restart() {
      clearInterval(timer);
      timer = setInterval(() => go(i + 1), 6000);
    }
    restart();
    let startX = 0;
    let deltaX = 0;
    hero.addEventListener('touchstart', (e) => {
      startX = e.changedTouches[0].clientX;
      deltaX = 0;
      clearInterval(timer);
    }, { passive: true });
    hero.addEventListener('touchmove', (e) => {
      deltaX = e.changedTouches[0].clientX - startX;
    }, { passive: true });
    hero.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 40) go(i + (deltaX < 0 ? 1 : -1));
      else restart();
    }, { passive: true });
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  document.querySelectorAll('[data-open-cart]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      drawer?.classList.add('open');
    });
  });
  document.querySelectorAll('[data-close-cart]').forEach((btn) => {
    btn.addEventListener('click', () => drawer?.classList.remove('open'));
  });
  drawer?.addEventListener('click', (e) => {
    if (e.target === drawer) drawer.classList.remove('open');
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      const submitter = e.submitter;
      if (submitter && (submitter.name === 'checkout' || submitter.classList.contains('shopify-payment-button__button'))) {
        return;
      }
      if (!(submitter && submitter.hasAttribute('data-ajax-add'))) return;
      e.preventDefault();
      const fd = new FormData(form);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('Add failed');
        window.location.reload();
      } catch (err) {
        form.submit();
      }
    });
  });

  document.querySelectorAll('[data-qty-minus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[name="quantity"]');
      if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[name="quantity"]');
      if (input) input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  document.querySelectorAll('[data-deal-timer]').forEach((box) => {
    const h = box.querySelector('[data-h]');
    const m = box.querySelector('[data-m]');
    const s = box.querySelector('[data-s]');
    function tick() {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      let left = Math.max(0, Math.floor((end - now) / 1000));
      if (h) h.textContent = String(Math.floor(left / 3600)).padStart(2, '0');
      left %= 3600;
      if (m) m.textContent = String(Math.floor(left / 60)).padStart(2, '0');
      if (s) s.textContent = String(left % 60).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });
})();
